import BaseProductSettings from "@/models/Products/ProductSettings/BaseProductSettings";

export default class LendingCardSettings extends BaseProductSettings {
}